import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import React, { useEffect, useState } from "react";
import Notification from "../../hooks/Notification";
import billService from "../../service/BillService";
import "./index.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import doiSoatService from "../../service/DoiSoatService";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import moment from "moment";
import { Paginator } from "primereact/paginator";

function LayLaiDoiSoat() {
  const notification = new Notification();
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);

  const [first, setFirst] = useState(0);
  const [totalRecord, setTotalRecord] = useState(0);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [doiSoats, setDoiSoats] = useState([]);


  const [paginate, setPaginate] = useState({
    page: 0,
    size: 10,
  });
useEffect(() => {
    getAllService();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paginate]);

const getAllService = async () => {
    showLoader();
    const dataBody = { ...paginate };
    const result = await doiSoatService.getAllDoiSoatChuDong(dataBody);
    console.log(result);
    if (result && result.status === 1000) {
      setDoiSoats(result.data);
      setTotalRecord(result.count);
    }
    hideLoader();
  };
const onHandleRefresh = () => {
    setFirst(1);

    setPaginate({
      page: 0,
      size: 10,
    });
  };
const renderRowIndex = (rowData, column) => {
    return column.rowIndex + 1 + first;
  };
  const renderCreateDate = (date) => {
    return (
      <>
        {date !== null
          ? moment(date).format("DD/MM/YYYY HH:mm:ss")
          : ""}
      </>
    );
  };
   const b64toBlob = (base64Data, contenttype) => {
    var byteString = atob(base64Data);
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);

    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: contenttype });
  };
  const onShowClick = async (rowData) => {
    const result = await doiSoatService.getDownloadDoiSoat(rowData.tag);
    console.log(result.data);
    var fileDownload = require("js-file-download");
      fileDownload(
        b64toBlob(
            result.data,
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        ),
        rowData.tag+".xlsx"
      );

  }
const renderTacVu = (data) => {
    return (
      <div>
        <i
          className="pi pi-download"
          style={{
            color: "blue",
            cursor: "pointer",
            textAlign: "center",
            paddingRight: "10px",
          }}
          onClick={() => onShowClick(data)}
          title={"Tài xuông"}
        />
      </div>
    );
  };
  const onPageChange = (event) => {
    setFirst(event.first);
    setPaginate({ ...paginate, size: event.rows, page: event.page });
  };
  const sendXMLTct = async () => {
    console.log(startTime);
    console.log(endTime);
    let datain = {endTime,startTime};
    const result = await billService.layLaiDoiSoat(datain);
    console.log(result);
    if(result.status == 1000){
    notification.notifySuccess(result.message); 
    getAllService();
    }else{
    notification.notifyError(result.message); 
    }
    
    
  };



  
 
  return (
    <div className="sentXML">
      <div className="card">
        <div className="p-fluid p-formgrid p-grid">
          <div className="p-field p-col-4">
            <p htmlFor="address">Thời gian bắt đầu</p>
            <Calendar id="time24" value={startTime} onChange={(e) => setStartTime(e.value)}  showTime showSeconds />
          </div>
          <div className="p-field p-col-4">
            <p htmlFor="address">Thời gian kết thúc</p>
            <Calendar id="time25" value={endTime} onChange={(e) => setEndTime(e.value)}  showTime showSeconds />
          </div>
         
        </div>
        <div className='button-xml' style={{marginBottom:"20px"}}>
          <Button
            label="Lấy đối soát"
            className="p-button-success"
            onClick={sendXMLTct}
          />
        </div>
        
        <DataTable value={doiSoats} emptyMessage="Không có dữ liệu">
                <Column
                  body={renderRowIndex}
                  header="STT"
                  headerStyle={{ width: "4rem" }}
                />
                <Column field={"tag"} header="Mã" 
                body={rowData => rowData.tag}
                />
                <Column field={"startDate"} header="Từ ngày"
                body={rowData => renderCreateDate(rowData.startDate)}
                />
                <Column
                  field={"endDate"}
                  header="Đến ngày"
                  className="p-text-nowrap p-text-truncate"
                  body={rowData => renderCreateDate(rowData.endDate)}
                />
                <Column field={"trangThai"} header="Trạng Thái" 
                body={rowData => rowData.trangThai}
                />
                {/* <Column field={"mngui"} header="Mã người gửi" />
                <Column field={"mnnhan"} header="Mã người nhận" /> */}
                <Column
                  field={"createDate"}
                  header="Thời gian tạo"
                  body={rowData => renderCreateDate(rowData.createDate)}
                />
                <Column
                  field={"tenhoso"}
                  header="Tác vụ"
                  className="p-text-center"
                  body={renderTacVu}
                />
              </DataTable>
<div className="p-d-flex p-mt-2">
        <div className="p-mt-3">
          <span>
            Tổng số <b>{totalRecord}</b> bản ghi
          </span>
        </div>
        <div className="p-ml-auto">
          <Paginator
            first={first}
            rows={paginate.size}
            totalRecords={totalRecord}
            rowsPerPageOptions={[10, 20, 50, 100]}
            onPageChange={(event) => onPageChange(event)}
            template=" RowsPerPageDropdown FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink "
          />
        </div>
      </div>

      </div>
    </div>
  );
}

export default LayLaiDoiSoat;
